import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

interface Skill {
  name: string;
  icon: string;
  level: number;
}

@Component({
  selector: 'app-skills',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skills.component.html',
  styleUrl: './skills.component.scss'
})
export class SkillsComponent implements OnInit {
  frontendSkills: Skill[] = [
    { name: 'Angular', icon: 'fab fa-angular', level: 95 },
    { name: 'React', icon: 'fab fa-react', level: 90 },
    { name: 'TypeScript', icon: 'fab fa-js-square', level: 92 },
    { name: 'HTML5', icon: 'fab fa-html5', level: 98 },
    { name: 'CSS3', icon: 'fab fa-css3-alt', level: 95 },
    { name: 'Bootstrap', icon: 'fab fa-bootstrap', level: 90 },
    { name: 'Sass', icon: 'fab fa-sass', level: 88 }
  ];

  backendSkills: Skill[] = [
    { name: '.NET Core', icon: 'fas fa-server', level: 95 },
    { name: 'C#', icon: 'fas fa-code', level: 93 },
    { name: 'Node.js', icon: 'fab fa-node-js', level: 85 },
    { name: 'Python', icon: 'fab fa-python', level: 80 },
    { name: 'REST API', icon: 'fas fa-exchange-alt', level: 92 },
    { name: 'GraphQL', icon: 'fas fa-project-diagram', level: 75 }
  ];

  databaseSkills: Skill[] = [
    { name: 'PostgreSQL', icon: 'fas fa-database', level: 90 },
    { name: 'SQL Server', icon: 'fas fa-database', level: 88 },
    { name: 'MongoDB', icon: 'fas fa-leaf', level: 80 },
    { name: 'Redis', icon: 'fas fa-memory', level: 75 }
  ];

  cloudSkills: Skill[] = [
    { name: 'Azure', icon: 'fab fa-microsoft', level: 85 },
    { name: 'Docker', icon: 'fab fa-docker', level: 82 },
    { name: 'Git', icon: 'fab fa-git-alt', level: 95 },
    { name: 'CI/CD', icon: 'fas fa-cogs', level: 80 },
    { name: 'IIS', icon: 'fas fa-server', level: 88 }
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    // Initialize language
    this.i18n.initializeLanguage();
  }
}
